import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import {
  EntityCfaApiSdkDeploymentsCard,
  EntityCfaApiSdkManagementCard,
  EntityCfaApiSdkDeploymentsTab,
  EntityCfaApiSdkComponentCodeManagementContent,
  EntityCfaApiSdkSystemCodeManagementContent,
  IfCfaApiSdkDeploymentsEnabled,
  IfCfaApiSdkCodeManagementEnabled,
  cfaApiSdkPlugin,
} from '@cfa-api-sdk/backstage-plugin';

const deploymentsCard = EntityCardBlueprint.make({
  name: 'deployments',
  params: {
    filter: 'kind:component',
    loader: async () =>
      compatWrapper(
        <IfCfaApiSdkDeploymentsEnabled>
          <EntityCfaApiSdkDeploymentsCard />
        </IfCfaApiSdkDeploymentsEnabled>,
      ),
  },
});

const managementCard = EntityCardBlueprint.make({
  name: 'code-management',
  params: {
    filter: 'kind:component',
    loader: async () =>
      compatWrapper(
        <IfCfaApiSdkCodeManagementEnabled>
          <EntityCfaApiSdkManagementCard />
        </IfCfaApiSdkCodeManagementEnabled>,
      ),
  },
});


const deploymentsTab = EntityContentBlueprint.make({
  name: 'deployments-tab',
  params: {
    path: '/deployments',
    title: 'Deployments',
    loader: async () => compatWrapper(<EntityCfaApiSdkDeploymentsTab />),
  },
});

const systemCodeManagementTab = EntityContentBlueprint.make({
  name: 'system-code-management',
  params: {
    path: '/code-management',
    title: 'Code Management',
    filter: 'kind:system',
    loader: async () =>
      compatWrapper(<EntityCfaApiSdkSystemCodeManagementContent />),
  },
});

const componentCodeManagementTab = EntityContentBlueprint.make({
  name: 'component-code-management',
  params: {
    path: '/code-management',
    title: 'Code Management',
    filter: 'kind:component,spec.type=service',
    loader: async () =>
      compatWrapper(<EntityCfaApiSdkComponentCodeManagementContent />),
  },
});

export const cfaApiSdkModule = createFrontendModule({
  pluginId: 'cfa-api-sdk',
  extensions: [
    deploymentsCard,
    managementCard,
    deploymentsTab,
    componentCodeManagementTab,
    systemCodeManagementTab,
  ],
});

export { cfaApiSdkPlugin };
